import { erebus } from "boot/axios";
import type { definitions } from "@erebus/api-types";

export type EvacuationStatus = definitions["pkg_evacuation.StatusResponse"];
export type CreateEvacuationRequest = definitions["pkg_evacuation.CreateRequest"];
export type EvacuationNotification = definitions["pkg_evacuation.EvacuationNotification"];

export default class EvacuationService {
  async getStatus(caseID: number, linkedCaseIDs: number[]): Promise<EvacuationStatus> {
    const params = linkedCaseIDs.length > 0
      ? { linkedCaseIDs: linkedCaseIDs.join(",") }
      : {};
    const res = await erebus.get<EvacuationStatus>(
      `/cases/${caseID}/evacuation-notification/status`,
      { params }
    );
    return res.data;
  }

  async sendNotification(caseID: number, payload: CreateEvacuationRequest): Promise<EvacuationNotification> {
    const res = await erebus.post<EvacuationNotification>(
      `/cases/${caseID}/evacuation-notification`,
      payload
    );
    return res.data;
  }
}
